import authenticationRoutes from '@routes/authenticationRoutes'
import billingRoutes from '@routes/billingRoutes'
import companyRoutes from '@routes/companyRoutes'
import dashboardRoutes from '@routes/dashboardRoutes'
import exportRoutes from '@routes/exportRoutes'
import fcpRoutes from '@routes/fcpRoutes'
import orphanClaimsRoutes from '@routes/orphanClaimsRoutes'
import pagesRoutes from '@routes/pagesRoutes'
import profileRoutes from '@routes/profileRoutes'
import reportRoutes from '@routes/reportRoutes'
import slipShareRoutes from '@routes/slipShareRoutes'
import userRoutes from '@routes/userRoutes'
import verificationRoutes from '@routes/verificationRoutes'

import miscRoutes from './miscRoutes'

export default new Array().concat(
  authenticationRoutes,
  billingRoutes,
  companyRoutes,
  dashboardRoutes,
  exportRoutes,
  fcpRoutes,
  orphanClaimsRoutes,
  pagesRoutes,
  profileRoutes,
  reportRoutes,
  slipShareRoutes,
  userRoutes,
  verificationRoutes,
  miscRoutes
)
